import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import icons from '../icons';
import Item from './Item';
import { isRTL } from '../config';

var Next =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Next, _React$PureComponent);

  var _super = _createSuper2(Next);

  function Next() {
    _classCallCheck(this, Next);

    return _super.apply(this, arguments);
  }

  _createClass(Next, [{
    key: "renderNext",
    value: function renderNext() {
      var text = this.props.text;
      var rtl = isRTL();

      if (rtl) {
        return text.prev || icons.AngleLeft;
      }

      return text.next || icons.AngleRight;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          current = _this$props.current,
          text = _this$props.text,
          total = _this$props.total,
          pageSize = _this$props.pageSize,
          disabled = _this$props.disabled,
          isSimple = _this$props.isSimple;
      var max = Math.ceil(total / pageSize);
      var next = current + 1;
      var className = text.next || isSimple ? "no-border arrow" : 'arrow';
      return (
        /*#__PURE__*/
        React.createElement(Item, {
          className: className,
          page: next,
          disabled: disabled || next > max,
          onClick: onChange
        }, this.renderNext())
      );
    }
  }]);

  return Next;
}(React.PureComponent);

Next.displayName = void 0;
Next.displayName = 'ShineoutPaginationNext';
export default Next;